export const PRODUCT_LIMIT = 10
export const FREE_PEN_PRICE = 800
export const FREE_PEN_QUANTITY = 1
export const MAXIMUM_ORDER_QUANTITY = 10

